/**
 * @description 神策埋点 在utils/point.js中引用
 * @author lidongliang
 * @date: 2020-03-23 10:42:30
 */
import sensors from 'sa-sdk-javascript'; // 神策埋点
let server_url = `https://sensorsdata.ppdai.com/sa/?project=${process.env.VUE_APP_SENSORS_PROJECT}`;

const initParam = {
	server_url: server_url,
	use_app_track: false, // 在APP内部就走app打点
	scrollmap: {}, // 触达图
	heatmap: {
		//是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
		//需要 JSSDK 版本号大于 1.7
		clickmap: 'default',
		//是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
		//需要 JSSDK 版本号大于 1.9.1
		scroll_notice_map: 'default'
	},
	show_log: true // 是否在console里面显示埋点数据
};
sensors.init(initParam);
/**
 * 设置公共属性
 */
sensors.register({
	product: 'other', // 产品线名称，对应各个产品线,没有则传other
	platform: 'H5', // 平台类型H5
	user_agent: window.navigator.userAgent, // user_agent字段和app的冲突了，改成了ua
	product_h5: 'bx_h5' // 保险项目
});
sensors.quick('autoTrack');
// let _openId = getCookie('openid');
// if (_openId) {
//   sensors.login(_openId);
// }

export default sensors;
